import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import state from './state'

const vuexLocal = new VuexPersistence({
  key: 'biblioteca-ibrvn',
  storage: window.localStorage
})

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions,
  plugins: [vuexLocal.plugin]
})
